import layout from './layout'
import fonts from './fonts'
import { pxToRem, pxToRemPure } from '../utils'

const gridConfig = {
  mediaQuery: 'screen',
  columns: {
    xs: 12,
    sm: 12,
    md: 12,
    lg: 12,
    xl: 12
  },
  gutterWidth: {
    xs: 1,
    sm: 1,
    md: 1.25,
    lg: 1.25,
    xl: 1.25
  },
  paddingWidth: {
    xs: 1,
    sm: 1,
    md: 0,
    lg: 0,
    xl: 0
  },
  container: {
    xs: 'full', // 'full' = max-width: 100%
    sm: pxToRemPure(layout.container.sm, true), // max-width: 600px
    md: pxToRemPure(layout.container.md, true), // max-width: 720px
    lg: pxToRemPure(layout.container.lg, true), // max-width: 960px
    xl: pxToRemPure(layout.container.xl, true) // max-width: 960px
  },
  breakpoints: {
    xs: 1,
    sm: pxToRemPure(layout.breakpoints.sm, true), // 480px
    md: pxToRemPure(layout.breakpoints.md, true), // 768px
    lg: pxToRemPure(layout.breakpoints.lg, true), // 1024px
    xl: pxToRemPure(layout.breakpoints.xl, true) // 1280px
  }
}

export default gridConfig
